import { Helmet } from 'react-helmet-async';
import { FaWhatsapp, FaGraduationCap, FaMapMarkerAlt, FaClock } from 'react-icons/fa';

const WHATSAPP_NUMBER = '918122552867';

const Contact = () => {
  const generalMsg  = 'Hi, I have a question about ChooseMyCollege.';
  const counselMsg  = 'Hi, I need guidance for TNEA 2025 college selection.';

  return (
    <>
      <Helmet>
        <title>Contact Us — ChooseMyCollege</title>
        <meta name="description" content="Contact ChooseMyCollege for TNEA college selection guidance, feedback, or any queries about Tamil Nadu engineering admissions." />
        <link rel="canonical" href="https://choosemycollege.in/contact" />
      </Helmet>

      <div className="max-w-2xl mx-auto py-6 space-y-5">

        {/* Header */}
        <div className="bg-gradient-to-br from-blue-700 to-indigo-700 rounded-2xl p-8 text-white text-center">
          <FaGraduationCap className="text-5xl mx-auto mb-4 opacity-90" />
          <h1 className="text-2xl font-bold mb-2">Get in Touch</h1>
          <p className="text-blue-200 text-sm">
            Questions about TNEA admissions, college selection, or the website?
            We're here to help.
          </p>
        </div>

        {/* WhatsApp cards */}
        <div className="grid md:grid-cols-2 gap-4">
          <a
            href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(counselMsg)}`}
            target="_blank" rel="noopener noreferrer"
            className="bg-white border border-gray-100 rounded-2xl p-6 shadow-sm hover:shadow-md hover:border-green-200 transition-all group"
          >
            <div className="flex items-center gap-3 mb-3">
              <div className="w-11 h-11 bg-green-100 text-green-600 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-green-500 group-hover:text-white transition-colors">
                <FaWhatsapp className="text-2xl" />
              </div>
              <div>
                <h2 className="font-bold text-gray-900 text-sm">Free Counselling</h2>
                <p className="text-xs text-gray-400">College selection guidance</p>
              </div>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed">
              Share your TNEA rank or cutoff — get a personalised list of colleges
              matched to your score and community.
            </p>
            <div className="mt-4 flex items-center gap-2 text-green-600 font-semibold text-sm">
              <FaWhatsapp />
              Chat on WhatsApp
            </div>
          </a>

          <a
            href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(generalMsg)}`}
            target="_blank" rel="noopener noreferrer"
            className="bg-white border border-gray-100 rounded-2xl p-6 shadow-sm hover:shadow-md hover:border-blue-200 transition-all group"
          >
            <div className="flex items-center gap-3 mb-3">
              <div className="w-11 h-11 bg-blue-100 text-blue-600 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-blue-600 group-hover:text-white transition-colors">
                <FaWhatsapp className="text-2xl" />
              </div>
              <div>
                <h2 className="font-bold text-gray-900 text-sm">General Enquiry</h2>
                <p className="text-xs text-gray-400">Feedback, data issues, partnerships</p>
              </div>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed">
              Found incorrect college data? Want to suggest a feature? Have a
              partnership proposal? Reach out directly.
            </p>
            <div className="mt-4 flex items-center gap-2 text-blue-600 font-semibold text-sm">
              <FaWhatsapp />
              Chat on WhatsApp
            </div>
          </a>
        </div>

        {/* Info strip */}
        <div className="bg-white border border-gray-100 rounded-2xl p-6 shadow-sm">
          <div className="grid md:grid-cols-2 gap-5">
            <div className="flex items-start gap-3">
              <div className="w-9 h-9 bg-indigo-50 text-indigo-600 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                <FaClock className="text-sm" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-800 text-sm mb-0.5">Response Time</h3>
                <p className="text-xs text-gray-500 leading-relaxed">
                  We reply within a few hours on weekdays.
                  During TNEA counselling season (July–Sept) response may take up to 24 hours due to high volume.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-9 h-9 bg-indigo-50 text-indigo-600 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                <FaMapMarkerAlt className="text-sm" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-800 text-sm mb-0.5">Based In</h3>
                <p className="text-xs text-gray-500 leading-relaxed">
                  Tamil Nadu, India.<br />
                  We cover all Anna University affiliated engineering colleges across all 38 districts.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Data correction note */}
        <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 text-sm text-amber-800">
          <strong>Found incorrect college data?</strong> We update our database regularly. If you notice
          wrong fees, incorrect NAAC grade, or missing hostel info for a college, please WhatsApp us with
          the college code and the correct details — we'll fix it promptly.
        </div>

      </div>
    </>
  );
};

export default Contact;
